/* nude-project clone — header interactions
   - theme.initWhenVisible shim (header-megamenu.js depends on it)
   - search modal toggle, desktop mega-menu hover, cart drawer trigger
   - sticky controller: hide on scroll-down, reveal solid on scroll-up, big-logo shrink */
(function () {
  window.theme = window.theme || {};
  if (!window.theme.initWhenVisible) {
    window.theme.initWhenVisible = function (opts) {
      try { (opts && opts.callback ? opts.callback : function () {})(); } catch (e) { console.error(e); }
    };
  }

  /* ---------- shared: header bottom position + close helpers ---------- */
  function setHeaderBottom() {
    var h = document.querySelector('.header-wrapper') || document.querySelector('.section-header'); if (!h) return;
    var b = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--header-bottom', b + 'px');
  }
  function closeMenuDrawer() {
    var d = document.querySelector('.menu-drawer-container[open]');
    if (d) { d.classList.remove('menu-opening'); d.removeAttribute('open'); }
  }

  /* ---------- search ---------- */
  function searchEl() { return document.getElementById('Search'); }
  function openSearch() {
    var s = searchEl(); if (!s) return;
    closeMenuDrawer();          // search + menu are mutually exclusive
    setHeaderBottom();          // anchor the search bar exactly below the header
    s.setAttribute('aria-hidden', 'false');
    var w = document.querySelector('.header-wrapper'); if (w) w.classList.add('open-search');
    var i = s.querySelector('input[type="search"]'); if (i) setTimeout(function () { i.focus(); }, 50);
  }
  function closeSearch() {
    var s = searchEl(); if (!s) return;
    s.setAttribute('aria-hidden', 'true');
    var w = document.querySelector('.header-wrapper'); if (w) w.classList.remove('open-search');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-action="toggle-search"]');
    if (toggle) { e.preventDefault(); var s = searchEl(); (s && s.getAttribute('aria-hidden') === 'false') ? closeSearch() : openSearch(); return; }
    if (e.target.closest('[data-action="close-search"]')) { e.preventDefault(); closeSearch(); return; }
    var cart = e.target.closest('.header__icon--cart');
    if (cart && document.getElementById('CartDrawer')) { e.preventDefault(); window.dispatchEvent(new CustomEvent('cart-drawer:open')); return; }
    document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) { d.removeAttribute('open'); }); }
  });

  /* ---------- mobile menu drawer ----------
     Dawn's <header-drawer> JS (which toggles the `menu-opening` slide-in class)
     isn't loaded. Apply `menu-opening` SYNCHRONOUSLY on the summary click — doing
     it on the async `toggle` event leaves a one-frame gap that flickers. */
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.menu-drawer-container > summary');
    if (summary) {
      var det = summary.parentElement;
      if (det.open) {
        det.classList.remove('menu-opening');
        document.documentElement.style.removeProperty('overflow');
      } else {
        closeSearch();
        setHeaderBottom();
        det.classList.add('menu-opening');
        document.documentElement.style.setProperty('overflow', 'hidden');
      }
      return; /* native <details> flips [open] in the same frame → no flicker */
    }
    var back = e.target.closest('.inner-menu__back-button');
    if (back) { var d2 = back.closest('details[open]'); if (d2) d2.removeAttribute('open'); return; }
    var link = e.target.closest('#menu-drawer a[href]');
    if (link) {
      var dd = document.querySelector('.menu-drawer-container[open]');
      if (dd) { dd.classList.remove('menu-opening'); dd.removeAttribute('open'); document.documentElement.style.removeProperty('overflow'); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('.menu-drawer-container[open]');
    if (d) { d.classList.remove('menu-opening'); d.removeAttribute('open'); document.documentElement.style.removeProperty('overflow'); }
  });

  /* ---------- desktop mega-menu hover ---------- */
  function bindHover() {
    if (!window.matchMedia('(min-width:1024px)').matches) return;
    document.querySelectorAll('.header__inline-menu li.menu-item').forEach(function (li) {
      var d = li.querySelector('details'); if (!d || li.dataset.npHover) return;
      li.dataset.npHover = '1';
      var t;
      li.addEventListener('mouseenter', function () {
        clearTimeout(t);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
        d.setAttribute('open', '');
      });
      li.addEventListener('mouseleave', function () { t = setTimeout(function () { d.removeAttribute('open'); }, 120); });
    });
  }

  /* sticky / hide-reveal / logo-shrink are handled by np-sticky-header.js (the reference StickyHeader) */

  /* ---------- transparent header → solid scheme on hover / open drawer-menu-search / scroll-up ---------- */
  function bindHeaderScheme() {
    var wrapper = document.querySelector('sticky-header.header-wrapper');
    if (!wrapper || wrapper.getAttribute('data-transparent') !== 'true') return; // only when header starts transparent
    var defScheme = wrapper.getAttribute('data-default-scheme') || 'color-scheme-1';
    var invScheme = wrapper.getAttribute('data-inverse-scheme') || 'color-scheme-3';
    var reasons = {};

    function apply() {
      var solid = false, k;
      for (k in reasons) { if (reasons[k]) { solid = true; break; } }
      if (solid) {
        wrapper.classList.remove('is-inverse', invScheme);
        wrapper.classList.add('is-solid', defScheme);
      } else {
        wrapper.classList.remove('is-solid', defScheme);
        wrapper.classList.add('is-inverse', invScheme);
      }
    }
    function set(reason, on) { if (reasons[reason] === !!on) return; reasons[reason] = !!on; apply(); }

    // hover
    wrapper.addEventListener('mouseenter', function () { set('hover', true); });
    wrapper.addEventListener('mouseleave', function () { set('hover', false); });

    // any open drawer / mega-menu / mobile menu / search → solid
    function checkOpens() {
      var open = false;
      if (wrapper.classList.contains('open-search')) open = true;
      if (!open && wrapper.querySelector('.header__inline-menu details[open]')) open = true;
      if (!open && document.querySelector('.menu-drawer-container[open]')) open = true;
      var cd = document.getElementById('CartDrawer');
      if (!open && cd && cd.classList.contains('is-open')) open = true;
      set('open', open);
    }
    var mo = new MutationObserver(checkOpens);
    mo.observe(wrapper, { attributes: true, subtree: true, attributeFilter: ['open', 'class'] });
    var cd = document.getElementById('CartDrawer');
    if (cd) mo.observe(cd, { attributes: true, attributeFilter: ['class'] });
    var mdc = document.querySelector('.menu-drawer-container');
    if (mdc) mo.observe(mdc, { attributes: true, attributeFilter: ['open'] });
    window.addEventListener('cart-drawer:open', function () { setTimeout(checkOpens, 0); });

    // scroll: solid while scrolling up (past the top); transparent at the very top / scrolling down
    var lastY = window.pageYOffset || 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
      if (y <= hh) set('scroll', false);          // near top → transparent
      else if (y < lastY - 2) set('scroll', true); // scrolling up → solid
      else if (y > lastY + 2) set('scroll', false);// scrolling down → transparent (header hides anyway)
      lastY = y;
    }, { passive: true });

    apply();
    checkOpens();
  }

  /* ---------- mobile menu drawer: anchor below header, lock scroll, pin header ----------
     Uses position:fixed body-lock (overflow:hidden leaks on iOS Safari → a scroll
     gesture would fire the sticky header's hide() and the header/close-button would
     vanish, freezing the user in the open drawer). Also pins the header via .menu-open. */
  function bindMenuDrawer() {
    var details = document.querySelector('.menu-drawer-container');
    if (!details) return;
    var header = document.querySelector('.section-header');
    var drawer = document.getElementById('menu-drawer');
    var savedY = 0, locked = false;
    function relocate() {
      /* Move the drawer to <body> so position:fixed anchors to the real viewport. Any
         transform / will-change / contain anywhere up the header chain (e.g. the header group's
         scroll-trigger transform) turns that ancestor into the containing block for fixed AND a
         stacking context — trapping the drawer inside the header. As a <body> child it escapes both. */
      if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
    }
    function lock() {
      if (locked) return; locked = true;
      savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-savedY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.documentElement.style.overflow = 'hidden';
      if (header) header.classList.add('menu-open');   // keep header (+close btn) visible while open
    }
    function unlock() {
      if (!locked) return; locked = false;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (header) header.classList.remove('menu-open');
      window.scrollTo(0, savedY);
    }
    var obs = new MutationObserver(function () {
      if (details.hasAttribute('open')) {
        closeSearch(); setHeaderBottom(); relocate(); lock();
        requestAnimationFrame(function () { if (drawer) drawer.classList.add('np-open'); });
      } else {
        if (drawer) drawer.classList.remove('np-open');
        unlock();
      }
    });
    obs.observe(details, { attributes: true, attributeFilter: ['open'] });
    window.addEventListener('resize', function () { if (details.hasAttribute('open')) setHeaderBottom(); });
  }

  function boot() { bindHover(); bindHeaderScheme(); bindMenuDrawer(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
